import Upsertable from '@/models/Upsertable'
import { useRecommendationStore } from '@/stores/recommendationStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Recommendation extends Upsertable {
  static store() {
    return useRecommendationStore()
  }

  store() {
    return Recommendation.store()
  }

  static find(uuid) {
    const store = Recommendation.store();
    return store.find(uuid)
  }
}

useModelName(Recommendation, "Recommendation")
ModelRegistry.register(Recommendation, "Recommendation")